import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { WrenchTheme } from '@wds/styles';
import 'react';
import { createUseStyles } from 'react-jss'; // eslint-disable-next-line @typescript-eslint/naming-convention

var Theme = _objectSpread(_objectSpread({}, WrenchTheme), {}, {
  // Add any additional question-related styles here
  keyline: {
    borderColor: WrenchTheme.semanticColor.muted,
    borderStyle: 'solid',
    borderWidth: '1px'
  }
});

var prefix = 'smq-';
var selectors = ["[class*='".concat(prefix, "']"), "[class*='".concat(prefix, "']::before"), "[class*='".concat(prefix, "']::after")];
createUseStyles(function (theme) {
  var fontFamily = theme.fontFamily;
  var resetStyles = {
    '-webkit-font-smoothing': 'antialiased',
    boxSizing: 'border-box',
    fontFamily: fontFamily.base,
    listStyle: 'none',
    margin: 0,
    padding: 0
  };
  return {
    '@global': _defineProperty({}, selectors.join(','), resetStyles)
  };
}, {
  // Ensure this gets added to as the first stylesheet
  // ref: https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/utils/getSheetIndex.js#L3-L16
  index: (Number.MIN_SAFE_INTEGER || -1e9) - 1,
  name: 'smquestions-global-styles'
});
export { Theme as T };